export const quiz1 = [
  {
    label: "A) Um programa de benefícios para clientes",
    point: "20",
    idPoint: "493f2d36-99f6-4710-94e0-3418ca66ced9",
    codePoint: "NACAOVCERRADA",
    correct: false,
  },
  {
    label:
      "B) Um evento de conexão, aprendizado e engajamento para o time VC começar o ano alinhados com as estratégias!",
    point: "100",
    idPoint: "21ff0518-29c5-43a8-be7f-0455da751c19",
    codePoint: "NACAOVCCERTA",
    correct: true,
  },
  {
    label: "C) Uma campanha externa de venda de produtos",
    point: "20",
    idPoint: "493f2d36-99f6-4710-94e0-3418ca66ced9",
    codePoint: "NACAOVCERRADA",
    correct: false,
  },
];
